import React, { useEffect, useState } from 'react';
import { ControlledTextField, ControlledTextFieldProps } from "./ControlledTextField";
import { EntityWithIdAndDescription } from "../../types/baseEntities";

interface AsyncSelectProps<TOption> extends ControlledTextFieldProps<TOption> {
    loadOptions: () => Promise<Array<TOption>> | undefined,
    filled?: boolean
    onlyOpenOnArrow?: boolean
}

export const AsyncSelect = <TOption extends EntityWithIdAndDescription>(props: AsyncSelectProps<TOption>) => {
    const [loading, setLoading] = useState(false);
    const [options, setOptions] = useState<EntityWithIdAndDescription[]>([])

    const { loadOptions } = props;

    useEffect(() => {
        const request = loadOptions();

        if (request) {
            setLoading(true);

            request.then(options => {
                setOptions(options);
                setLoading(false);
            }).catch(error => {
                console.log(error)
                setLoading(false)
            })
        }
    }, [loadOptions]);

    return (
        <ControlledTextField
            {...props}
            onlyOpenOnArrow={props.onlyOpenOnArrow ?? true}
            select
            options={loading ? undefined : options}
        />
    )
};
